import { createFileRoute } from "@tanstack/react-router";
import { IncreaseAccountPage } from "@/components/IncreaseBanking/Account";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  return <IncreaseAccountPage accountId={params.accountId} />;
}

export const Route = createFileRoute("/_authenticated/increase-banking/$accountId/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
